import React from 'react';
import { Modal } from 'antd';
import { AlertIcon, CrownWhite, Cross, LinkIcon, CheckIcon, WarningIcon } from '../icons'; // Assuming Cross icon is available in icons
import { Button, SecondaryButton } from 'pages/application/Login';
import './style.css';

interface IPermissionGuardModalProps {
  open: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  alertText: string;
}

export const PermissionGuardModal: React.FC<IPermissionGuardModalProps> = ({ open, onClose, onUpgrade, alertText }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={450}
      centered
      footer={null}
      maskClosable={true}
      closeIcon={<div onClick={onClose} style={{cursor: 'pointer'}}><Cross color='#CACED9'/></div>}
    >
      <div className="permission-guard-modal">
        <div className="permission-guard-modal__header">
          <div className="permission-guard-modal__icon-container">
            <CrownWhite />
          </div>
          <h2 className="permission-guard-modal__title">Premium feature</h2>
        </div>

        <div className="permission-guard-modal__alert">
          <WarningIcon />
          <span className="permission-guard-modal__alert-text">
          {alertText}
          </span>
        </div>

        <p className="permission-guard-modal__message">
          You've exceeded the limits of your plan. To continue, please upgrade your subscription or check your available limits.
        </p>

        <div className="permission-guard-modal__actions">
          <SecondaryButton onClick={onClose}>
            Got it
          </SecondaryButton>
          <Button onClick={onUpgrade}>
            Upgrade Plan
          </Button>
        </div>
      </div>
    </Modal>
  );
}; 